var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-fields-residential-template-card"},[_c('div',{staticClass:"custom-fields-residential-template-card__image",style:({ backgroundImage: `url(${_vm.thumbnail})` })}),_c('div',{staticClass:"custom-fields-residential-template-card__content"},[_vm._v(_vm._s(_vm.value.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }